export default "/toucoin-eth.410480e1705fb98d3f0c799e1000bc11.svg";